<template>
  <a-card :bordered='false'>
    <a-row>
      <a-col :span="18" offset="3">
        <div v-show="!stampShowed">
          <div v-show="!showFlag" id="pdfCentent">
            <h3 align="left" style="margin-top: -5px"></h3>
            <h1 align="center">申请开标封标</h1>
            <a-spin :spinning="confirmLoading">
              <a-form-item labelAlign="left"
                          :labelCol="{span:2}"
                          :wrapperCol="{span:10}"
                           label="标题" required
                          style="width: 800px"
              >
                <a-input v-model="noticeName" placeholder="请输入标题"/>
              </a-form-item>
              <a-form-item  label="封标内容" labelAlign="left" :labelCol="{span:3}" :wrapperCol="{span:24}" style="min-height: 300px" required>
                <JEditor v-model="jeditor.value" id="editorCentent"></JEditor>
              </a-form-item>
            </a-spin>
          </div>
          <a-card v-show="showFlag"  title="申请进度">
            <a-card v-show="showFlag"  title="申请进度">
              <a-steps :current="currentStep" size="small">
                <a-step title="申请" />
                <a-step title="待审核" />
                <a-step title="已审核" :description="aduitDesc"/>
              </a-steps>
            </a-card>
          </a-card>

          <div v-if="showFlag" v-html="extractHtml" id="printContent"></div>

        </div>
      </a-col>
    </a-row>

<!--    <div>-->
<!--      <iframe v-show="stampShowed" ref='signIframe' frameBorder="no" :src="pdfParams.signedPdfUrl" width='100%' height="900" style='border-bottom:1px solid #3D3D3D;'></iframe>-->
<!--    </div>-->

    <div style="text-align:center;margin:auto;">
      <a-button v-show="!stampShowed" v-if="EditFlag" type="primary" style="margin-right: 10px" @click="reEdit()">重新申请</a-button>
      <a-button v-show="!stampShowed" v-if="cancleFlag" type="primary" style="margin-right: 10px" @click="cancle()">取消</a-button>
<!--      <a-button v-show="!stampShowed" :disabled="showFlag" type="primary" style="margin-left: 10px" @click="sign">签章</a-button>-->
<!--      <a-button  v-show='!stampShowed && showFlag' type='primary' @click="signShow" style="margin-left: 10px">签章文件查看</a-button>-->
      <SignatureButton
        v-show="!stampShowed"
        ref="SignatureButton"
        :pdf-params="pdfParams"
        :stampShowed="stampShowed"
        :disabled="showFlag"
        @sign="sign"
        @signShow="signShow"
      ></SignatureButton>
      <!-- <a-button v-show="stampShowed" htmlType="button" @click='reWrite' type="primary" style="margin-right: 10px">重新编辑</a-button>
       <a-button v-show="stampShowed" htmlType="button" @click='getSignedPdf' type="primary" style="margin-right: 10px">获取签章文件</a-button>-->
      <a-button type="primary" :disabled="submitFlag" v-show="showFlag" style="margin-left: 10px" @click="add()">提交</a-button>
<!--      <a-button type="primary" :disabled="!showFlag" v-show="showFlag" style="margin-left: 10px" v-print="'#printContent'">打印</a-button>-->
    </div>
<!--    <stamp-->
<!--      :is-stamp="isStamp"-->
<!--      ref="stamp"-->
<!--      :pdf-params="pdfParams"-->
<!--      @checkStampForm="checkStampForm"-->
<!--      @changeIsStamp="changeIsStamp"-->
<!--    ></stamp>-->


    <SignatureComponent
      v-show="stampShowed"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    >
      <template  v-slot:footer>
        <slot>
          <a-button type="primary" :disabled="submitFlag" v-show="!showFlag" style="margin-right: 10px" @click="add()">提交</a-button>
<!--          <a-button type="primary" :disabled="!showFlag" v-show="!showFlag" v-print="'#printContent'">打印</a-button>-->
        </slot>
      </template>
    </SignatureComponent>
    <SignFileShow-modal ref="modalForm"></SignFileShow-modal>
  </a-card>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import JEditor from '@/components/fzis/JEditor'
import { toHtml } from '@/utils/htmlUtil'
import SignFileShowModal from '../modules/SignFileShowModal'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
export default {
  components: {
    JEditor,
    WorkChangeStamp, stamp ,SignatureComponent,SignatureButton,
    SignFileShowModal,
  },
  name: 'Seal',
  data() {
    return {
      bottonStatus: false,
      bidProjectId: '',
      sectionId: '',
      visible: false,
      confirmLoading: false,
      showFlag: false,
      submitFlag: false,
      EditFlag: false,
      cancleFlag: false,
      noticeName: '',
      isSeal: true,
      tmBidSeal: {},
      boOpenStatus: {},
      statusText: '未封标',
      jeditor: {
        value: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      url: {
        add: '/ebid-ce/tmBidSeal/add',
      },
      isStamp: true,
      isNeedStamp: true,
      pdfParams: {
        isEditorCuring: "1",
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '1',
        sectionId: '1',
        type: 'OpenSeal',
        typeZh: '开标封标',
        htmlTitle: '开标封标',
        fp: '4',
        signType:'1'//1:统一CA，2：工改签章
      },
      stampShowed: false,
      extractHtml: '',
      currentStep:1,
      aduitDesc:'',
    }
  },
  filters: {},
  created() {},
  computed: {},
  methods: {
    setBidProjectId(id, sectionId) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.bidProjectId = id
      this.sectionId = sectionId
      this.pdfParams.bidProjectId = id
      this.pdfParams.sectionId = sectionId
      //设置本页面标识，用于redis key记录当前页面签章信息
      this.pdfParams.pageId = this.sectionId + "_Seal_" + new Date().getTime();
      this.getBoOpenStatus()
      this.getTmBidSeal()
    },
    getBoOpenStatus() {
      let that = this
      getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
        sectionId: that.sectionId,
      }).then((res) => {
        if (res.success) {
          this.boOpenStatus = res.result
        }
      })
    },
    checkIsOpenFinish(){
      if (this.boOpenStatus.isOpenFinish==1) {
        this.$message.error('该项目已结标！')
      return false
      }
      return true
    },
    sign(type) {
      let that = this
      if (that.noticeName == '') {
        this.$message.error('请填写封标标题!')
        return
      }
      if (that.jeditor.value == '') {
        this.$message.error('请填写封标内容!')
        return
      }

      this.pdfParams.signType = type;
      this.extractHtml = '';
      this.$refs.stamp.checkStamp();

      /*let that = this
      this.$confirm({
        title: '提示',
        content: '您确定要进行签章操作吗？',
        onOk() {
          that.extractHtml = ''
          that.$refs.stamp.checkStamp()
        },
        onCancel(){
          that.pdfParams.pageId="";
          that.pdfParams.signedPdfUrl="";
          that.stampShowed = false;
          that.$refs.stamp.pdfUrl=null;
        },
      })*/
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    //重新编辑
    reWrite(){
      this.pdfParams.pageId="";
      this.pdfParams.signedPdfUrl="";
      this.stampShowed = false;
      this.$refs.stamp.pdfUrl=null;
    },
    // getSignedPdf(){
    //   let that = this;
    //   that.$confirm({
    //     title: '确认信息',
    //     content: '请确认是否已经完成签章，未完成则先完成签章，完成则点击确认获取签章文件！',
    //     onOk() {
    //       that.$refs.stamp.getPdfUrl();
    //     },
    //     onCancel(){
    //     },
    //   })
    // },
    changeStatus() {
      let that = this
      if (this.tmBidSeal.isPublish == 0 && this.tmBidSeal.rebootFlag == 0) {
        this.statusText = '申请中'
        this.currentStep=1
        this.aduitDesc =''
        this.showFlag = true
        this.submitFlag = true
        this.cancleFlag = false
        return
      }
      if (this.tmBidSeal.isPublish == 1 && this.tmBidSeal.rebootFlag == 0) {
        this.currentStep=2
        this.aduitDesc ='审核通过（封标中）'
        this.statusText = '封标中'
        this.showFlag = true
        this.submitFlag = true
        return
      }
      if (this.tmBidSeal.isPublish == 2) {
        this.statusText = '不通过'
        this.currentStep=2
        this.aduitDesc ='审核不通过'
        this.showFlag = true
        this.submitFlag = true
        this.EditFlag = true
        return
      }
      if (this.tmBidSeal.rebootFlag == 1) {
        this.statusText = '重新启用'
        this.currentStep=2
        this.aduitDesc ='审核通过（已重新启用）'
        this.statusText = '封标中'
        this.showFlag = true
        this.submitFlag = true
        this.EditFlag = true
        return
      }
    },
    getTmBidSeal() {
      let that = this
      getAction('/ebid-ce/tmBidSeal/getOne', {
        bidProjectId: that.bidProjectId,
        sectionId: that.sectionId,
      }).then((res) => {
        if (res.success) {
          that.tmBidSeal = res.result
          that.extractHtml = that.tmBidSeal.resultHtml
          that.changeStatus()
        } else {
          that.showFlag = false
        }
      })
    },
    reEdit() {
      this.EditFlag = false
      this.cancleFlag = true
      this.showFlag = false
      this.submitFlag = false
      this.noticeName=''
      this.jeditor.value=''
    },
    cancle() {
      this.cancleFlag = false
      this.EditFlag = true
      this.getBoOpenStatus()
      this.getTmBidSeal()
    },
    changeIsStamp(val) {
      this.stampShowed = val
    },
    checkStampForm(callback) {
      callback(true)
    },
    add() {
      let flag =  this.checkIsOpenFinish()
      if(!flag){
        return
      }
      let that = this
      if (that.noticeName == '') {
        this.$message.error('请填写封标标题!')
        return
      }
      if (that.jeditor.value == '') {
        this.$message.error('请填写封标内容!')
        return
      }
      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先获取签章文件后再进行保存提交')
        return
      }
      this.$confirm({
        title: '提示',
        content: '您确定提交吗？',
        onOk() {
          let params = {}
          params.bidProjectId = that.bidProjectId
          params.sectionId = that.sectionId
          params.noticeName = that.noticeName
          params.noticeContent = that.jeditor.value
          params.bulletinType = '1'
          params.resultHtml = toHtml('pdfCentent')
          console.log(params)
          postAction(that.url.add, params).then((res) => {
            if (res.success) {
              that.$message.success(res.result)
              that.getBoOpenStatus()
              that.getTmBidSeal()
            }
          })
          that.stampShowed = false
        },
      })
    },
  },
}
</script>

<style  scoped>
  body{
    border: 1px solid white;
  }
@import '~@assets/less/common.less';
</style>